import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../scss/index.scss";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import {
  initialValues,
  validationSchema,
} from "../../componentes/CambiarClave";
import imaLogo from "../../imagenes/logo.png";
import { Grid, Header, Image, Segment } from "semantic-ui-react";
import {
  cambiar_contrasena,
  repetir_contrasena,
  proceso_de_cambio_de_clave_incorrecto,
  cambio_de_contrasena_correcto,
  contrasena,
} from "../../utils/traductor";
import { apiUsuario } from "../../api/usuario";
import Swal from "sweetalert2";
import { estiloColores } from "../../estilos/colores";
import { ENTORNO, HabilitarGoogleRecaptcha } from "../../utils/constantes";
import { getPermiteCambiarEmail } from "../../utils/variablesLocales";
import { estiloSegmento } from "../../estilos";
import { TextField } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import { apigoogleRecaptchaV3 } from "../../api";
import ReactRecaptcha3 from "react-google-recaptcha3";

const apigooglerecaptchav3 = HabilitarGoogleRecaptcha
  ? new apigoogleRecaptchaV3()
  : null;
const apiusuario = new apiUsuario();

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const ValidarTokenRecaptcha = async (
  tokenGoogleRecaptchaV3,
  ipPublicaValor,
  password,
  navigateToIngresar
) => {
  if (HabilitarGoogleRecaptcha) {
    const respuestaVerificacionRecaptcha = await apigooglerecaptchav3.verificar(
      tokenGoogleRecaptchaV3,
      ipPublicaValor
    );

    if (respuestaVerificacionRecaptcha === true) {
      IngresarConfirmar(password, navigateToIngresar);
    } else {
    }
  } else {
    IngresarConfirmar(password, navigateToIngresar);
  }
};

const IngresarConfirmar = async (password, navigateToIngresar) => {
  const response = await apiusuario.cambiarClave(password);

  if (response === "Ok") {
    Swal.fire({
      title: "",
      text: cambio_de_contrasena_correcto,
      icon: "success",
      confirmButtonText: "Ok",
      confirmButtonColor: estiloColores.Azul,
    }).then(function () {
      //destruir el recaptcha
      if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

      navigateToIngresar();
    });
  } else {
    Swal.fire({
      title: "Error!",
      text: response,
      icon: "error",
      confirmButtonText: "Ok",
      confirmButtonColor: estiloColores.Gris,
    });
  }
};

export function CambiarClave(props) {
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [showPassword1, setShowPassword1] = React.useState(false);
  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleMouseDownPassword1 = (event) => {
    event.preventDefault();
  };

  const navigate = useNavigate();

  const navigateToIngresar = () => {
    navigate(ENTORNO.URL_APLICACION + "/Ingresar");
  };

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (getPermiteCambiarEmail() === "1") {
          //validacion google recaptcha v3
          //1. calculo ip publica
          const ipPublica = require("react-public-ip");
          const ipPublicaValor = (await ipPublica.v4()) || "";

          //2. obtengo token
          if (HabilitarGoogleRecaptcha) {
            ReactRecaptcha3.getToken().then(
              (tokenGoogleRecaptchaV3) => {
                ValidarTokenRecaptcha(
                  tokenGoogleRecaptchaV3,
                  ipPublicaValor,
                  formik.values.password,
                  navigateToIngresar
                );
              },
              (error) => {
                console.log(error);
              }
            );
          } else {
            IngresarConfirmar(formik.values.password, navigateToIngresar);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  useEffect(() => {
    if (HabilitarGoogleRecaptcha) {
      ReactRecaptcha3.init(ENTORNO.GOOGLE_RECAPTCHA_V3_SITEKEY).then(
        (status) => {}
      );
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <form onSubmit={formik.handleSubmit}>
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {cambiar_contrasena}
              </Typography>
              <IconButton
                size="large"
                aria-label="display more actions"
                edge="end"
                color="inherit"
                type="submit"
              >
                <CheckIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Segment style={estiloSegmento.Pasajero}>
              <Grid textalign="center" container style={{ padding: "5em 0em" }}>
                <Grid.Row>
                  <div className="ingresar">
                    <Grid.Column style={{ maxWidth: 450 }}>
                      <Image
                        src={imaLogo}
                        className="logoCrearCuenta"
                        centered
                      />
                      <Header as="h3">{cambiar_contrasena}</Header>
                      <Box
                        //component="form"
                        sx={{
                          "& > :not(style)": { m: 1, width: "25ch" },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <TextField
                          id="password"
                          label={contrasena}
                          placeholder={contrasena}
                          variant="standard"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.password &&
                            Boolean(formik.errors.password)
                          }
                          helperText={
                            formik.touched.password && formik.errors.password
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <TextField
                          id="passwordRepetir"
                          label={repetir_contrasena}
                          placeholder={repetir_contrasena}
                          variant="standard"
                          name="passwordRepetir"
                          type={showPassword1 ? "text" : "password"}
                          value={formik.values.passwordRepetir}
                          onChange={formik.handleChange}
                          error={
                            formik.errors.passwordRepetir &&
                            Boolean(formik.errors.passwordRepetir)
                          }
                          helperText={
                            formik.touched.passwordRepetir &&
                            formik.errors.passwordRepetir
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword1}
                                  onMouseDown={handleMouseDownPassword1}
                                >
                                  {showPassword1 ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                    </Grid.Column>
                  </div>
                </Grid.Row>
              </Grid>
            </Segment>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </React.Fragment>
      </form>
    </div>
  );
}
